import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { ContractorSearchInterfacePropsType } from '../..';
import { LogoSvg } from '../../assets/Logo.svg';

const { tablet, mobile } = mediaQueries();

const KEY_NAME = 'PageTopButton';

type PageTopButtonPropsType = ContractorSearchInterfacePropsType;

export const PageTopButton = (props: PageTopButtonPropsType) => {
  const onClickHandler = React.useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div
      css={css`
        width: fit-content;
        margin-inline: auto;
      `}
    >
      <button
        type='button'
        onClick={onClickHandler}
        id={`ga_event_${KEY_NAME}_button`}
        css={css`
          color: #959595;
          font-size: 12px;
          font-weight: bold;
          text-align: center;
          width: 180px;
          padding: 11px 0;
          background-color: #ebebeb;
          border-radius: 6px;

          &:hover {
            opacity: 0.8;
          }
        `}
      >
        ページのトップへ戻る
      </button>
    </div>
  );
};
